import T from "@/components/forms/TextField.module.css";

import { WButton } from "@/components/button/WButton.tsx";
import { FieldButtonGroup } from "@/components/forms/FieldButtonGroup.tsx";
import { FormSubmitButton } from "@/components/forms/FormSubmitButton.tsx";
import { WHookForm } from "@/components/forms/WHookForm.tsx";
import {
    addImpersonatorMutation,
    type AccessDelegationWithType,
} from "@/modules/access/delegation/accessDelegationApi.ts";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { Trans, useLingui } from "@lingui/react/macro";
import { FieldError, Input, TextField } from "react-aria-components";
import { useForm, type SubmitHandler } from "react-hook-form";

export interface AddImpersonationFormProps {
    obj: AccessDelegationWithType;
    onClose: () => void;
}

export function AddImpersonationForm({ obj, onClose }: AddImpersonationFormProps) {
    const { t } = useLingui();
    const createImpersonationMutation = useStandardMutation(addImpersonatorMutation);

    interface Inputs {
        grantee_username: string;
    }

    /// Form
    const form = useForm<Inputs>({
        disabled: createImpersonationMutation.isPending,
    });
    const { register } = form;

    const onSubmit: SubmitHandler<Inputs> = async ({ grantee_username }) => {
        await createImpersonationMutation.mutateAsync({
            grantee_username,
            delegation_id: obj.id,
        });
        onClose();
    };

    return (
        <WHookForm form={form} onSubmit={onSubmit}>
            <TextField isRequired type="email" aria-label="Grantee username" className={T.TextField}>
                <FieldButtonGroup>
                    <Input
                        className={T.Input}
                        placeholder={t`User's email`}
                        autoFocus={true}
                        {...register("grantee_username")}
                    />
                    <FormSubmitButton icon="jp-icon-add">
                        <Trans>Add user</Trans>
                    </FormSubmitButton>
                    <WButton action={onClose}>
                        <Trans>Close</Trans>
                    </WButton>
                </FieldButtonGroup>
                <FieldError />
            </TextField>
        </WHookForm>
    );
}
